import {
  Component,
  OnInit,
  ViewChild,
  Input,
  OnDestroy,
  Output,
  EventEmitter
} from '@angular/core';
import { AuthService } from './../../shared/models/auth.service';
import { PrePostTripQuestionModel } from '../models/pre-post-trip-question.model';
import { PrePostTripQuestionService } from '../models/pre-post-trip-question.service';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { forEach } from '@angular/router/src/utils/collection';
import { VehicleService } from '../../vehicle/models/vehicle.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  WeGoConfig,
  IAPIResponse,
  IKeyValueInterface,
  ApplicationRouteURL,
  PermissionType,
  DataListModel,
  RoleLevel,
  Permission,
  WeGoAuthorizedLink
} from '../../shared/config';
import { Location } from '@angular/common';
import { InstanceService } from '../../instance/models/instance.service';
import { DropdownModel } from '../../report/models/report-filter.model';
import { CustomerService } from '../../customer/models/customer.service';
import { CompanyService } from '../../company/models/company.service';
import { OrganizationService } from '../../organization/models/organization.service';
import { SharedVehicleGroupService } from '../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { CustomeTripQuestion } from '../models/custom-question.model';
import { parse } from 'url';
import { BasePermissionModel } from '../../shared/models/base-permission-model';

const moment = require('moment');

@Component({
  selector: 'wego-pre-post-trip-question',
  template: require('../views/pre-post-trip-question.component.html'),
  providers: [
    PrePostTripQuestionService,
    InstanceService,
    CompanyService,
    SharedVehicleGroupService,
    VehicleService
  ],
  styles: [
    `
      .toggle-border {
        border: red 1px solid;
      }
    `
  ]
})
export class PrePostTripQuestionComponent implements OnInit, OnDestroy {
  prepostQuestionList: CustomeTripQuestion[];
  postTripQuestionIndex: any;
  addpreposttripQuestionLink: WeGoAuthorizedLink;
  preQuestionListIndex: any;
  deleteMessage: string;
  isEditMode: boolean;
  module: any;
  breadCrumbList: any;
  urlPrePostQuestionList: string;
  sub: any;
  vehicleList: DropdownModel[];
  CompanyList: DropdownModel[];
  VehicleList: DropdownModel[];
  SVGList: DropdownModel[];
  permissionType: string;
  pageName: string;
  InstanceList: DropdownModel[];
  prePostQuestionHashId: any;
  FinalCountOfBeforeRequired: number[];
  TotalcountBeforeRequired: number[] = [];
  countRemainigBeforeRequired: number[] = [];
  postTripQuestionList: CustomeTripQuestion[] = [];
  preTripQuestionList: CustomeTripQuestion[] = [];
  fazTripQuestionList: CustomeTripQuestion[] = [];
  apiErrorMsg: any;
  prePostTripQuestionList: CustomeTripQuestion[] = [];
  DataListModel: DataListModel;
  isLoading: boolean;
  checked: boolean;
  urlDefaultPage: string;
  model: PrePostTripQuestionModel;
  modelCustomTripQuestion: CustomeTripQuestion;
  countSelectedArrayBeforeRequired: number[];
  countBeforeRequired: number = 0;
  countBeforeOptional: number = 0;
  countAfterRequired: number = 0;
  countAfterOptional: number = 0;
  countIsRequired: number = 0;
  countIsOptional: number = 0;
  countFazRequired: number = 0;
  countFazOptional: number = 0;
  roleLevel = RoleLevel;
  customTripQuestionList1: CustomeTripQuestion[];
  restoreItem: CustomeTripQuestion;
  popupMsg: string;
  private SuccessMsg: string;
  inheritRestoreMessage: string;
  // errorModel: IKeyValueInterface[];

  get PreTripBeforeRequired(): number[] {
    return this.ChangeOrderSequence(true, true, 'PREBEFORE');
  }

  get PreTripBeforeOptional(): number[] {
    return this.ChangeOrderSequence(true, false, 'PREBEFORE');
  }

  get PreTripAfterRequired(): number[] {
    return this.ChangeOrderSequence(true, true, 'PREAFTER');
  }

  get PreTripAfterOptional(): number[] {
    return this.ChangeOrderSequence(true, false, 'PREAFTER');
  }

  get PostTripRequired(): number[] {
    return this.ChangeOrderSequenceForPost(true, true, 'POST');
  }

  get PostTripOptional(): number[] {
    return this.ChangeOrderSequenceForPost(true, false, 'POST');
  }

  get FazTripRequired(): number[] {
    return this.ChangeOrderSequenceForFaz(true, true, 'FAZ');
  }

  get FazTripOptional(): number[] {
    return this.ChangeOrderSequenceForFaz(true, false, 'FAZ');
  }

  // _vehicleHashId: string = "";
  // @Input("VehicleMasterHashId")
  // set vehicleMasterHashId(hashId: string) {
  //   this._vehicleHashId = hashId;
  //   this.GetPrePostTripQuestionList();
  // }
  // get vehicleMasterHashId() {
  //   return this._vehicleHashId;
  // }

  @Input('ErrorModel') errorModel: IKeyValueInterface[];
  @Input('CustomTripQuestionList')
  customTripQuestionList: Array<CustomeTripQuestion> = [];
  
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('UpdatePrePostTripQuestion') public updatePrePostTripQuestion: any;
  @Output('OnPrePostTripQuestionSetting')
  onPrePostTripQuestionSetting = new EventEmitter();
  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('alertInheritModal') public alertInheritModal: any;

  @Input('VehicleView') VehicleView: boolean = false;

  @Input('InstanceView') InstanceView: boolean = false;

  //customeTripQuestionList = new Array<CustomeTripQuestion>();

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    private prePostTripQuestionService: PrePostTripQuestionService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private vehicleService: VehicleService,
    private locationService: Location,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.model = new PrePostTripQuestionModel();
    this.modelCustomTripQuestion = new CustomeTripQuestion();
    this.pageName = 'Pre Post Trip Question';
    this.module = this.translate.instant('LblPrePostTripQuestion');
    this.DataListModel = new DataListModel();
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );

    this.urlPrePostQuestionList = this.authService.GetURL(
      ApplicationRouteURL.URL_PRE_POST_QUESTION
    );

    this.addpreposttripQuestionLink = new WeGoAuthorizedLink(
      '',
      Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE,
      PermissionType.INSERT,
      'fa fa-plus-square',
      ''
    );

    if (this.prePostQuestionHashId) {
      this.permissionType = PermissionType.EDIT;
    } else {
      this.permissionType = PermissionType.INSERT;
    }

    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  public GetPrePostTripQuestionList(
    instanceHashId: string,
    companyHashId: string,
    svgHashId: string,
    vehicleHashId: string,
    basePermissionModel: BasePermissionModel,
    isInsert: boolean = false,
    isInstance: boolean = false
  ) {
    this.model.instanceHashId = instanceHashId;
    this.model.companyHashId = companyHashId;
    this.model.svgHashId = svgHashId;
    this.model.vehicleHashId = vehicleHashId;
    this.model.basePermissionModel = basePermissionModel;
    this.model.isInsert = isInsert;
    this.model.isInstance = isInstance;
    this.sub = this.activeRoute.params.subscribe(params => {
      this.isEditMode = true;
      this.prePostTripQuestionService
        .GetPrePostQuestionById(this.model)
        .subscribe(
          res => {
            this.modelCustomTripQuestion = res.data;
            this.prePostTripQuestionList = res.data;
            this.customTripQuestionList = this.prePostTripQuestionList;
            this.onPrePostTripQuestionSetting.emit({
              customTripQuestionList: this.customTripQuestionList
            });
            this.preTripQuestionList = this.prePostTripQuestionList.filter(
              x => x.questionType == 'PREBEFORE' || x.questionType == 'PREAFTER'
            );

            this.postTripQuestionList = this.prePostTripQuestionList.filter(
              x => x.questionType == 'POST'
            );

            this.fazTripQuestionList = this.prePostTripQuestionList.filter(
              x => x.questionType == 'FAZ'
            );            

            this.countBeforeRequired = this.preTripQuestionList.filter(
              x =>
                x.isActive == true &&
                x.questionType == 'PREBEFORE' &&
                x.isRequired == true
            ).length;
            this.countBeforeOptional = this.preTripQuestionList.filter(
              x =>
                x.isActive == true &&
                x.questionType == 'PREBEFORE' &&
                x.isRequired == false
            ).length;
            this.countAfterRequired = this.preTripQuestionList.filter(
              x =>
                x.isActive == true &&
                x.questionType == 'PREAFTER' &&
                x.isRequired == true
            ).length;
            this.countAfterOptional = this.preTripQuestionList.filter(
              x =>
                x.isActive == true &&
                x.questionType == 'PREAFTER' &&
                x.isRequired == false
            ).length;
            this.countIsRequired = this.postTripQuestionList.filter(
              x => x.isActive && x.isRequired == true
            ).length;
            this.countIsOptional = this.postTripQuestionList.filter(
              x => x.isActive && x.isRequired == false
            ).length;
            this.countFazRequired = this.fazTripQuestionList.filter(
              x => x.isActive && x.isRequired == true
            ).length;
            this.countFazOptional = this.fazTripQuestionList.filter(
              x => x.isActive && x.isRequired == false
            ).length;            
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    });
  }

  public inhertChanged($event: any, item: any) {
    if (!item.isInherit) {
      this.restoreItem = item;
      this.inheritRestoreMessage = this.translate.instant(
        'LblRestoreInheritConfirmation',
        [this.module]
      );
      this.alertInheritModal.show();
    }
  }

  SuccessAlertRestoreModalClick(): void {
    this.RestorePrePostQuestion(this.restoreItem.originalParentQuestionhashId);
  }

  HideRestoreAlertModal(): void {
    this.restoreItem.isInherit = false;
    this.alertInheritModal.hide();
  }

  public RestorePrePostQuestion(prePostQuestionHashId: string) {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.isEditMode = false;
      //prePostQuestionHashId = params["id"] || "";
      if (prePostQuestionHashId != '') {
        this.isEditMode = true;
        this.prePostTripQuestionService
          .GetPrePostTripQuestionByHashId(prePostQuestionHashId)
          .subscribe(
            res => {
              if (res.data) {
                this.restoreItem.isRequired = res.data.isRequired;
                this.restoreItem.isActive = res.data.isActive;
                this.restoreItem.isRequired = res.data.isRequired;
                this.restoreItem.orderNo = res.data.orderNo;
                this.restoreItem.questionType = res.data.questionType;
              }
              this.alertInheritModal.hide();
            },
            error => {
              this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
              this.alertInheritModal.hide();
            }
          );
      }
    });
  }

  public ChangeOrderSequence(
    isActive: boolean,
    isRequired: boolean,
    questionType: string
  ) {
    if (this.preTripQuestionList) {
      let selectedValueArray = this.preTripQuestionList
        .filter(
          x =>
            x.isActive == isActive &&
            x.questionType == questionType &&
            x.isRequired == isRequired
        )
        .map(x => parseInt(x.orderNo.toString()));

      let intermidiateArray = this.convertLengthToArray(
        selectedValueArray.length
      );

      let dropDownArray = this.filterUniqueValue(
        intermidiateArray,
        selectedValueArray
      );

      dropDownArray.push(0);
      this.customTripQuestionList = [];
      this.preTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.postTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.fazTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });      

      this.onPrePostTripQuestionSetting.emit({
        customTripQuestionList: this.customTripQuestionList
      });
      return dropDownArray.sort((a, b) => {
        return a - b;
      });
    }
    return [0];
  }

  public ChangeOrderSequenceForPost(
    isActive: boolean,
    isRequired: boolean,
    questionType: string
  ) {
    if (this.postTripQuestionList) {
      let selectedValueArray = this.postTripQuestionList
        .filter(
          x =>
            x.isActive == isActive &&
            x.questionType == questionType &&
            x.isRequired == isRequired
        )
        .map(x => parseInt(x.orderNo.toString()));

      let intermidiateArray = this.convertLengthToArray(
        selectedValueArray.length
      );

      let dropDownArray = this.filterUniqueValue(
        intermidiateArray,
        selectedValueArray
      );

      dropDownArray.push(0);
      this.customTripQuestionList = [];
      this.preTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.postTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.fazTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.onPrePostTripQuestionSetting.emit({
        customTripQuestionList: this.customTripQuestionList
      });
      return dropDownArray.sort((a, b) => {
        return a - b;
      });
    }
    return [0];
  }

  public ChangeOrderSequenceForFaz(
    isActive: boolean,
    isRequired: boolean,
    questionType: string
  ) {
    if (this.fazTripQuestionList) {
      let selectedValueArray = this.fazTripQuestionList
        .filter(
          x =>
            x.isActive == isActive &&
            x.questionType == questionType &&
            x.isRequired == isRequired
        )
        .map(x => parseInt(x.orderNo.toString()));

      let intermidiateArray = this.convertLengthToArray(
        selectedValueArray.length
      );

      let dropDownArray = this.filterUniqueValue(
        intermidiateArray,
        selectedValueArray
      );

      dropDownArray.push(0);
      this.customTripQuestionList = [];
      this.preTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.postTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.fazTripQuestionList.forEach(x => {
        this.customTripQuestionList.push(x);
      });

      this.onPrePostTripQuestionSetting.emit({
        customTripQuestionList: this.customTripQuestionList
      });
      return dropDownArray.sort((a, b) => {
        return a - b;
      });
    }
    return [0];
  }  

  public getCount($event: any, item: any) {
    if (item.isPreQuestion) {
      if (
        $event.currentTarget.checked == true &&
        item.questionType == 'PREBEFORE'
      ) {
        this.countBeforeRequired += 1;
        this.countBeforeOptional -= 1;
        item.orderNo = 0;
        this.ChangeOrderSequence(true, true, 'PREBEFORE');
      } else if (
        $event.currentTarget.checked == false &&
        item.questionType == 'PREBEFORE'
      ) {
        this.countBeforeRequired -= 1;
        this.countBeforeOptional += 1;
        item.orderNo = 0;
        this.ChangeOrderSequence(true, false, 'PREBEFORE');
      }
      if (
        $event.currentTarget.checked == false &&
        item.questionType == 'PREAFTER'
      ) {
        this.countAfterOptional += 1;
        this.countAfterRequired -= 1;
        item.orderNo = 0;
        this.ChangeOrderSequence(true, false, 'PREAFTER');
      } else if (
        $event.currentTarget.checked == true &&
        item.questionType == 'PREAFTER'
      ) {
        this.countAfterOptional -= 1;
        this.countAfterRequired += 1;
        item.orderNo = 0;
        this.ChangeOrderSequence(true, true, 'PREAFTER');
      } else {
        /// this.count1 += 1;
      }
    } else if (item.isFazQuestion) {
      if ($event.currentTarget.checked == false) {
        this.countFazRequired -= 1;
        this.countFazOptional += 1;
        item.orderNo = 0;
        this.ChangeOrderSequenceForFaz(true, false, 'FAZ');
      } else {
        this.countFazRequired += 1;
        this.countFazOptional -= 1;
        item.orderNo = 0;
        this.ChangeOrderSequenceForFaz(true, true, 'FAZ');
      }
    } else {
      if ($event.currentTarget.checked == false) {
        this.countIsRequired -= 1;
        this.countIsOptional += 1;
        item.orderNo = 0;
        this.ChangeOrderSequenceForPost(true, false, 'POST');
      } else {
        this.countIsRequired += 1;
        this.countIsOptional -= 1;
        item.orderNo = 0;
        this.ChangeOrderSequenceForPost(true, true, 'POST');
      }
    }
  }

  convertLengthToArray(countIsBeforeRequired: number) {
    var finalValue: number[] = [];
    for (let i = 1; i <= countIsBeforeRequired; i++) {
      finalValue.push(i);
    }
    return finalValue;
  }

  filterUniqueValue(TotalCount: number[], selectedCount: number[]) {
    var res = TotalCount.filter(v => {
      return selectedCount.indexOf(v) == -1;
    });
    return res;
  }

  AddCurrentSelectedValue(FinalSeletedValue: number[], currentOrderNo: number) {
    FinalSeletedValue.push(currentOrderNo);
    return FinalSeletedValue;
  }
  counter(i: number) {
    // /this.GetRemainingCount()
    return new Array(i);
  }

  public ShowAddPrePostQuestion(
    questionType: string,
    prePostQuestion: CustomeTripQuestion,
    iitem: number,
    isEditMode: boolean = true
  ) {
    if (!prePostQuestion) {
      prePostQuestion = new CustomeTripQuestion();
      prePostQuestion.questionType = questionType;
      prePostQuestion.orderNo = 0;
      prePostQuestion.isEditable = true;
      prePostQuestion.isDeletable = true;
      prePostQuestion.isActive = true;
    }
    this.updatePrePostTripQuestion.show(
      questionType,
      prePostQuestion,
      iitem,
      isEditMode
    );
  }

  public onClose($event: any) {

    if (!$event.isEditMode) {
      this.customTripQuestionList.push($event.model);
    }

    this.preTripQuestionList = this.customTripQuestionList.filter(
      x => x.questionType == 'PREBEFORE' || x.questionType == 'PREAFTER'
    );
    this.postTripQuestionList = this.customTripQuestionList.filter(
      x => x.questionType == 'POST'
    );
    this.fazTripQuestionList = this.customTripQuestionList.filter(
      x => x.questionType == 'FAZ'
    );

    this.onPrePostTripQuestionSetting.emit({
      customTripQuestionList: this.customTripQuestionList
    });
  }

  public OnBackClick() {
    this.locationService.back();
  }

  OnSubmit(forms: any) {
    this.isLoading = true;
    this.preTripQuestionList.forEach(x => {
      this.model.customeTripQuestion.push(x);
    });

    this.postTripQuestionList.forEach(x => {
      this.model.customeTripQuestion.push(x);
    });

    this.fazTripQuestionList.forEach(x => {
      this.model.customeTripQuestion.push(x);
    });

    this.prePostTripQuestionService
      .UpdatePrePostTripQuestion(this.model)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.SuccessMsg;
            this.ShowSuccessPopup();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public SuccessModalClick(): void {
    this.router.navigate([this.urlPrePostQuestionList]);
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ShowAlertModal(index: any, questionType: string): void {
    let prePostQuestionList: CustomeTripQuestion[];
    if (questionType == 'PRE') {
      prePostQuestionList = this.preTripQuestionList.filter(
        x => x.prePostEndDate == null
      );
    } else if (questionType == 'FAZ') {
      prePostQuestionList = this.fazTripQuestionList.filter(
        x => x.prePostEndDate == null
      );
    } else {
      prePostQuestionList = this.postTripQuestionList.filter(
        x => x.prePostEndDate == null
      );
    }

    if (prePostQuestionList[index].prePostQuestionHashId) {
      this.deleteMessage = this.translate.instant(
        'LblRecordDeleteConfirmation',
        [this.module]
      );
      this.preQuestionListIndex = index;
      this.prepostQuestionList = prePostQuestionList;
      this.alertModal.show();
    } else {
      if (questionType == 'PRE') {
        this.preTripQuestionList.splice(index, 1);
      } else if (questionType == 'FAZ') {
          this.fazTripQuestionList.splice(index, 1);
      } else {
        this.postTripQuestionList.splice(index, 1);
      }
    }
  }

  public SuccessAlertModalClick(): void {
    this.removePreQuestionDetail(
      this.preQuestionListIndex,
      this.prepostQuestionList
    );
    this.alertModal.hide();
  }

  public removePreQuestionDetail(
    index: any,
    prepostQuestionList: CustomeTripQuestion[]
  ) {
    //let abc = this.preTripQuestionList.filter(x => x.prePostEndDate == null);
    if (prepostQuestionList[index].prePostQuestionHashId) {
      prepostQuestionList[index].prePostEndDate = moment()
        .utc()
        .format('DD-MM-YYYY HH:mm');
    }
    this.preQuestionListIndex = null;
  }

  public GetPrePostQuestions(preTripQuestionList: CustomeTripQuestion[]) {
    return preTripQuestionList.filter(x => x.prePostEndDate == null);
  }

  public HideAlertModal(): void {
    this.alertModal.hide();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question/components/pre-post-trip-question.component.ts